import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeEmergency = () => {
  const [EmergencyUser, setEmergencyUser] = useState([]);
  const [OpeningHourTopUser, setOpeningHourTopUser] = useState([]);
  const [OpeningHourUser, setOpeningHourUser] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getbannerCard1");
      setEmergencyUser(response.data);
    };

    fetchData();
  }, []);


// opening hour  top api 
useEffect(() => {
  const fetchData = async () => {
    const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getbannerTopCard2");
    setOpeningHourTopUser(response.data);
  };

  fetchData();
}, []);


// opening hour api 
useEffect(() => {
  const fetchData = async () => {
    const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getbannerCard2");
    setOpeningHourUser(response.data);
  };

  fetchData();
}, []);

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>
        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          <h2>Emergency Cases</h2>
          {EmergencyUser.map((user) => {
            
            return (
              <div key={user.id}>
                {" "}
                <h3>
                  {user.heading}{" "}
                  <Link to={`/Emergency-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                </h3>
                <p dangerouslySetInnerHTML={{ __html: user.description }}></p>
                <h6>{user.number}</h6>
              </div>
            );
          })}

          <hr/>

          <h2>Opening Hours</h2>
          {OpeningHourTopUser.map((user) => {
            
            return (
              <div key={user.id}>
                {" "}
                <h3>
                  {user.heading}{" "}
                  <Link to={`/OpeningHour-top-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                </h3>
              </div>
            );
          })}

          <br/>

          {OpeningHourUser.map((user) => {
            
            return (
              <div key={user.id}>
                {" "}
                <h3>
                  {user.day}{" "}
                  <Link to={`/OpeningHour-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                </h3>
                <h6>{user.time}</h6>
              </div>
            );
          })}

        </div>
      </div>
    </div>
  );
};

export const HomeEmergencyEdit = () => {
  const [Emergencyuser, setEmergencyUser] = useState({
    heading: "",
    description: "",
    number: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // ✅ Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setEmergencyUser({ ...Emergencyuser, [name]: value });
  };

  // ✅ Load CKEditor script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) => {
          window.CKEDITOR.instances[instance].destroy(true);
        });
      }
    };
  }, []);

  // ✅ Fetch Emergency data
  const fetchEmergencyData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getonebannerCard1/${id}`
      );
      if (response.data.success) {
        setEmergencyUser(response.data.data);

        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.description
          );
        }
      }
    } catch (error) {
      console.error("Error fetching Emergency data!", error);
      toast.error("Failed to load Emergency data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) {
      fetchEmergencyData();
    }
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Emergencyuser.description || "");
    }
  }, [Emergencyuser.description, editorLoaded]);

  // ✅ Submit form data
  const submitForm = async (e) => {
    e.preventDefault();

    const updatedData = {
      heading: Emergencyuser.heading,
      description: window.CKEDITOR.instances.editor.getData(),
      number: Emergencyuser.number
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatebannerCard1/${id}`,
        updatedData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/Emergency");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error updating the Emergency!", error);
      toast.error("Failed to update Emergency.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Emergency">
                <button
                  type="button"
                  className="close"
                >
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Emergencyuser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                  required
                />
                <br/>
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea id="editor"></textarea>
                <br/>
              </div>

              <div className="form-group">
                <label>Emergancy Number</label>
                <input
                  type="number"
                  value={Emergencyuser.number}
                  onChange={changeHandler}
                  className="form-control"
                  name="number"
                  required
                />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Emergency">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const EmergencyAdd = () => {
  const [EmergencyData, setEmergencyData] = useState({
    heading: "",
    description: "",
    number: ""
  });

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setEmergencyData((prev) => ({ ...prev, [name]: value }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!EmergencyData.heading || !EmergencyData.description || !EmergencyData.number) {
      toast.error("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(
        "https://admin.gosaviadvanceddentalclinic.com/api/createbannerCard1",
        EmergencyData
      );
      toast.success("Emergency added successfully!");
      navigate("/Emergency"); // Redirect after success
    } catch (error) {
      console.error("Error adding Emergency:", error);
      toast.error("Failed to add Emergency!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12"/>
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
      <div className="add-banner">
        <Link to="/Emergency"> <i className="fa-solid fa-xmark"></i></Link>
        <h3>Add Emergency Data</h3>
        <form className="row" onSubmit={submitForm}>
          <div className="col-lg-12 col-md-12 col-sm-12 inputform">
            <label htmlFor="heading">Heading</label>
            <input
              type="text"
              onChange={inputHandler}
              value={EmergencyData.heading}
              id="heading"
              name="heading"
              placeholder="Enter Heading"
            />
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 inputform">
            <label htmlFor="description">Description</label>
            <textarea
              onChange={inputHandler}
              value={EmergencyData.description}
              id="description"
              name="description"
              placeholder="Enter Description"
              rows="4"
            ></textarea>
          </div>

          <div className="col-lg-12 col-md-12 col-sm-12 inputform">
            <label htmlFor="number">Number</label>
            <input
              type="text"
              onChange={inputHandler}
              value={EmergencyData.number}
              id="number"
              name="number"
              placeholder="Enter Number"
            />
          </div>
          <div className="mobilesubmitform">
            <button type="submit">Add Data</button>
          </div>
        </form>
      </div>
      </div>
      </div>
    </div>
  );
};

// opening hour data 

export const HomeOpeningHourTopEdit = () => {
    const [OpeningHouruser, setOpeningHourUser] = useState({
      heading: "",
    });
  
    const { id } = useParams();
    const navigate = useNavigate();
  
    // ✅ Handle input change
    const changeHandler = (e) => {
      const { name, value } = e.target;
      setOpeningHourUser({ ...OpeningHouruser, [name]: value });
    };
  
    // ✅ Fetch OpeningHour data
    const fetchOpeningHourData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonebannerTopCard2/${id}`
        );
        if (response.data.success) {
          setOpeningHourUser(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching OpeningHour data!", error);
        toast.error("Failed to load OpeningHour data.");
      }
    };
  
    useEffect(() => {
      fetchOpeningHourData();
    }, [id]);
  
    // ✅ Submit form data
    const submitForm = async (e) => {
      e.preventDefault();
  
      const updatedData = {
        heading: OpeningHouruser.heading
      };
  
      try {
        const response = await axios.put(
          `https://admin.gosaviadvanceddentalclinic.com/api/updatebannerTopCard2/${id}`,
          updatedData,
          { headers: { "Content-Type": "application/json" } }
        );
  
        if (response.data.success) {
          setOpeningHourUser(updatedData);
          toast.success("Data updated successfully!");
          navigate("/Emergency");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("There was an error updating the OpeningHour!", error);
        toast.error("Failed to update OpeningHour.");
      }
    };
  
    return (
      <div
        className="modal fade show"
        id="update_heading"
        tabIndex={-1}
        style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
        aria-modal="true"
      >
        <div className="modal-dialog">
          <form onSubmit={submitForm}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit</h5>
                <Link to="/Emergency">
                  <button type="button" className="close">
                    <span aria-hidden="true">
                      <i className="fa-solid fa-xmark"></i>
                    </span>
                  </button>
                </Link>
              </div>
  
              <div className="modal-body">
                <div className="form-group">
                  <label>Heading</label>
                  <input
                    type="text"
                    value={OpeningHouruser.heading}
                    onChange={changeHandler}
                    className="form-control"
                    name="heading"
                    required
                  />
                  <br/>
                </div>
  
                </div>
  
              <div className="modal-footer">
                <Link to="/Emergency">
                  <button type="button" className="btn btn-secondary">
                    Close
                  </button>
                </Link>
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };
  

  export const HomeOpeningHourEdit = () => {
    const [OpeningHouruser, setOpeningHourUser] = useState({
      day: "",
      time: "",
    });
  
    const { id } = useParams();
    const navigate = useNavigate();
  
    // ✅ Handle input change
    const changeHandler = (e) => {
      const { name, value } = e.target;
      setOpeningHourUser({ ...OpeningHouruser, [name]: value });
    };
  
    // ✅ Fetch OpeningHour data
    const fetchOpeningHourData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonebannerCard2/${id}`
        );
        if (response.data.success) {
          setOpeningHourUser(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching OpeningHour data!", error);
        toast.error("Failed to load OpeningHour data.");
      }
    };
  
    useEffect(() => {
      fetchOpeningHourData();
    }, [id]);
  
    // ✅ Submit form data
    const submitForm = async (e) => {
      e.preventDefault();
  
      const updatedData = {
        day: OpeningHouruser.day,
        time: OpeningHouruser.time
      };
  
      try {
        const response = await axios.put(
          `https://admin.gosaviadvanceddentalclinic.com/api/updatebannerCard2/${id}`,
          updatedData,
          { headers: { "Content-Type": "application/json" } }
        );
  
        if (response.data.success) {
          setOpeningHourUser(updatedData);
          toast.success("Data updated successfully!");
          navigate("/Emergency");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("There was an error updating the OpeningHour!", error);
        toast.error("Failed to update OpeningHour.");
      }
    };
  
    return (
      <div
        className="modal fade show"
        id="update_heading"
        tabIndex={-1}
        style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
        aria-modal="true"
      >
        <div className="modal-dialog">
          <form onSubmit={submitForm}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit</h5>
                <Link to="/Emergency">
                  <button type="button" className="close">
                    <span aria-hidden="true">
                      <i className="fa-solid fa-xmark"></i>
                    </span>
                  </button>
                </Link>
              </div>
  
              <div className="modal-body">
              <div className="form-group">
                  <label>Day</label>
                  <input
                    type="text"
                    value={OpeningHouruser.day}
                    onChange={changeHandler}
                    className="form-control"
                    name="day"
                    required
                  />
                  <br/>
                </div>
  
                <div className="form-group">
                  <label>Time</label>
                  <input
                    type="text"
                    value={OpeningHouruser.time}
                    onChange={changeHandler}
                    className="form-control"
                    name="time"
                    required
                  />
                </div>
              </div>
  
              <div className="modal-footer">
                <Link to="/Emergency">
                  <button type="button" className="btn btn-secondary">
                    Close
                  </button>
                </Link>
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };


